export default __webpack_public_path__ + "static/media/FP_GR_F.657dfbcd.png";